import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const VideoFileIcon = (props: IconProps) => (
  <Icon width="75px" height="75px" viewBox="0 0 75 75" {...props}>
    <path d="M53.96 32.813V21.874a3.13 3.13 0 0 0-3.117-3.125H13.436a3.13 3.13 0 0 0-3.117 3.125v31.25a3.13 3.13 0 0 0 3.117 3.125h37.407a3.13 3.13 0 0 0 3.117-3.125V42.187l12.469 12.5V20.313l-12.469 12.5Z" />
  </Icon>
);

export default memo(VideoFileIcon);
